// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll-wrapper[data-v-6ed4b9f2] {\n  scroll-behavior: smooth;\n}\n.scroll-wrapper[data-v-6ed4b9f2]::-webkit-scrollbar {\n  display: none;\n}\n\n/*Hide scrollbar for IE, Edge and Firefox*/\n.scroll-wrapper[data-v-6ed4b9f2] {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.btn-left[data-v-6ed4b9f2],\n.btn-right[data-v-6ed4b9f2] {\n  height: 1.75rem;\n  width: 1.75rem;\n  top: calc(50% - 0.875rem);\n  box-shadow: 0px 0px 20px 20px white;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
